import React, { useEffect, useRef, useState, useCallback } from "react";
import linkedin from "../../assets/images/linkedin.png";
import { useLocation, useNavigate } from "react-router-dom";
import { Collapse } from "flowbite";

const Navbar = () => {
  const target = useRef(null);
  const trigger = useRef(null);
  // const teamButton = useRef(null);
  // const teamDropdown = useRef(null);
  // const otherButton = useRef(null);
  // const otherDropdown = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  // const dispatch = useDispatch();
  const [bool, setbool] = useState(false);
  const boolfunc = useCallback(() => {
    setbool(true);
  }, []);

  //Mobile Navbar func
  const mobile = useCallback(() => {
    const hammenu = target.current;
    const nav = trigger.current;

    if (!hammenu || !nav) return;

    const navoptions = {
      onCollapse: () => { },
      onExpand: () => { },
      onToggle: () => { },
    };
    const mobnav = new Collapse(hammenu, nav, navoptions);
    mobnav.expand();
    mobnav.collapse();

    if (bool === true) {
      mobnav.collapse();
    }
  }, [bool]);
  //Other Dropdown function
  // const otherDrop = () => {
  //   const other = otherButton.current;
  //   const otherdown = otherDropdown.current;
  //   const otheroptions = {
  //     placement: "bottom",
  //     triggerType: "click",
  //     offsetSkidding: 0,
  //     offsetDistance: 10,
  //     delay: 300,
  //     onHide: () => {},
  //     onShow: () => {},
  //     onToggle: () => {},
  //   };
  //   const dropdownother = new Dropdown(otherdown, other, otheroptions);
  //   dropdownother.show();

  //   dropdownother.hide();
  // };
  useEffect(() => {
    mobile();
    // otherDrop();
  }, [mobile]);

  return (
    <nav className="bg-gray-900 sticky dark:bg-white-900  w-full z-20 p-4 top-0 left-0  border-gray-200 dark:border-gray-600  ">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-2 overflow-visible">
        <a
          href="#!"
          onClick={(e) => {
            e.preventDefault();
            navigate({
              pathname: `${process.env.PUBLIC_URL}/`,
            });
          }}
          className="flex items-center cursor-pointer  "
        >
          {/* <img src={logo} className="h-8 mr-5" alt="probing minds logo" /> */}
          <span className="self-center text-2xl font-Kalam text-white whitespace-nowrap dark:text-white uppercase">
            Shyam DEvakumaran
          </span>
        </a>
        <div className="flex md:order-2 overflow-hidden">
          <button
            data-collapse-toggle="navbar-sticky"
            id="hammenu"
            ref={trigger}
            type="button"
            className="inline-flex items-center p-2 text-lg text-white hover:text-gray-600   rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600 overflow-visible"
            aria-controls="navbar-sticky"
            aria-expanded="false"
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-6 h-6"
              aria-hidden="true"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
        </div>

        <div
          className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
          id="navbar-sticky"
          aria-current="page"
          ref={target}
        >
          <ul className="flex flex-col p-1 md:p-0 mt-2 font-medium   rounded-lg bg-gray-900 md:flex-row md:space-x-8 md:mt-0 md:border-0 md:bg-gray-900 dark:bg-gray-900 md:dark:bg-gray-900 dark:border-gray-700 ">
            <li>
              {location.pathname === `${process.env.PUBLIC_URL}/` ||
                location.pathname === `${process.env.PUBLIC_URL}/home` ? (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    boolfunc();
                    navigate({
                      pathname: `${process.env.PUBLIC_URL}/`,
                    });
                  }}
                  className="block px-4 py-2 pl-3 pr-4  rounded
                  xl:inline xl:bg-white uppercase  text-white  
                   xl:hover:bg-white  xl:mb-8 xl:font-semibold xl:text-black xl:py-2 
                   xl:px-4 xl:hover:border-transparent xl:rounded"
                >
                  Home
                </span>
              ) : (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    boolfunc();
                    navigate({
                      pathname: `${process.env.PUBLIC_URL}/`,
                    });
                  }}
                  className="block px-4 py-2 pl-3 pr-4  rounded
                  xl:inline  uppercase  text-white  
                    xl:mb-8 xl:font-semibold xl:text-white xl:py-2 xl:px-2 xl:hover:border-transparent 
                    xl:rounded"
                >
                  Home
                </span>
              )}
            </li>

            <li>
              {location.pathname === `${process.env.PUBLIC_URL}/projects` ? (
                <span
                  style={{ cursor: "pointer" }}
                  className="block px-4 py-2 pl-3 pr-4  rounded
                  xl:inline xl:bg-white uppercase  text-white 
                   xl:hover:bg-white  xl:mb-8 xl:font-semibold xl:text-black xl:py-2 
                   xl:px-4 xl:hover:border-transparent xl:rounded"
                  onClick={() => {
                    boolfunc();
                    navigate({
                      pathname: `${process.env.PUBLIC_URL}/projects`,
                    });
                  }}
                >
                  Projects
                </span>
              ) : (
                <span
                  style={{ cursor: "pointer" }}
                  className="block px-4 py-2 pl-3 pr-4  rounded
                  xl:inline xl:bg-gray-900 uppercase  text-white   xl:hover:bg-gray-900
                    xl:mb-8 xl:font-semibold xl:text-white xl:py-2 xl:px-2 xl:hover:border-transparent 
                    xl:rounded"
                  onClick={() => {
                    boolfunc();
                    navigate({
                      pathname: `${process.env.PUBLIC_URL}/projects`,
                    });
                  }}
                >
                  Projects
                </span>
              )}
            </li>

            <li>
              {location.pathname === `${process.env.PUBLIC_URL}/experience` ? (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    boolfunc();
                    navigate({
                      pathname: `${process.env.PUBLIC_URL}/experience`,
                    });
                  }}
                  className="block px-4 py-2 pl-3 pr-4  rounded
                  xl:inline xl:bg-white uppercase  text-white 
                   xl:hover:bg-white  xl:mb-8 xl:font-semibold xl:text-black xl:py-2 
                   xl:px-4 xl:hover:border-transparent xl:rounded"
                >
                  Experience
                </span>
              ) : (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    boolfunc();
                    navigate({
                      pathname: `${process.env.PUBLIC_URL}/experience`,
                    });
                  }}
                  className="block px-4 py-2 pl-3 pr-4  rounded
                  xl:inline xl:bg-gray-900 uppercase  text-white  xl:hover:bg-gray-900
                    xl:mb-8 xl:font-semibold xl:text-white xl:py-2 xl:px-2 xl:hover:border-transparent 
                    xl:rounded"
                >
                  Experience
                </span>
              )}
            </li>

            <li>
              <a
                style={{ cursor: "pointer" }}
                href="https://drive.google.com/file/d/1N-hIcTQu1ami0oFBJRvVIQgvXiueFSCK/view?usp=drive_link"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-4 py-2 pl-3 pr-4  rounded
                  xl:inline xl:bg-gray-900 uppercase  text-white  
                    xl:mb-8 xl:font-semibold xl:text-white xl:py-2 xl:px-2 xl:hover:border-transparent 
                    xl:rounded"
              >
                Resume
              </a>
            </li>

            <div class="w-full space-y-2 border-gray-500 dark:border-gray-700 flex flex-col -ml-1 sm:flex-row lg:space-y-0 md:w-max lg:border-l">
              <li>
                <a
                  href="https://www.linkedin.com/in/Shyamdevakumaran/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    boolfunc();
                  }}
                  className="block px-2 pl-5 "
                >
                  <img src={linkedin} alt="linkedin" className="h-7" />
                </a>
              </li>
              {/* <button
                ref={otherButton}
                id="others"
                data-dropdown-toggle="dropdownNavbar2"
                data-dropdown-trigger="hover"
                className="text-white flex ml-5  font-semibold font-poppins  text-lg"
              >
                V2{" "}
                <svg
                  className="w-5 h-5 mt-1 ml-1"
                  aria-hidden="true"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button> */}
              {/* <div
                ref={otherDropdown}
                id="dropdownNavbar2"
                className="z-40 hidden font-normal bg-white divide-y divide-gray-100 rounded shadow w-37 dark:bg-gray-700 dark:divide-gray-600"
              >
                <ul
                  className="py-2 text-sm text-gray-700 dark:text-gray-400"
                  aria-labelledby="dropdownLargeButton"
                >
                  <a
                    className="text-black cursor-pointer hover:bg-blue-800 hover:text-white font-semibold font-poppins block px-4 py-2 pl-3 pr-4 text-lg"
                    href="https://shyamdevakumaran0.web.app/index.html"
                    target="_blank"
                    rel="noopener"
                  >
                    V1
                  </a>
                </ul>
              </div> */}
            </div>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
